<template>
  <div>
    <draggable
    v-bind="dragOptions"
    tag="ul"
    class="list-group list-group-flush list"
    :list="list"
    :value="value"
    handle=".handle-task"
    @input="emitter"
    :move="onMove"
  >
    <transition-group type="transition" name="flip-list">
      <li class="list-group-item draggable task-group"
          :key="task.id" v-for="(task, key) in realValue">
        <div class="row align-items-center task-item">
          <div class="col-auto ml-5">

          </div>
          <div class="col ml--2 col-title">
            <h5 class="mb-0"
              v-text="$t(task.taskType)">
            </h5>
            <h4 class="mb-0">
               <router-link
                 v-if="readOnly"
                 :to="publicTaskPageUrl(task.id)">
                {{ task.title }}
              </router-link>
              <router-link
                v-else
                :to="editTaskRoute(task.taskType, task.id)">
                {{ task.title }}
              </router-link>
            </h4>
          </div>
          <div v-if="!readOnly" class="col-auto pr-4 col-status">
            <el-tooltip v-if="task.required"
                        class="task-tooltip"
                        :content="$t('Required')"
                        :openDelay=300
                        effect="light"
                        placement="left">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            </el-tooltip>
            <el-tooltip v-if="task.needReview"
                        class="task-tooltip"
                        :openDelay=300
                        effect="light"
                        :content="$t('Need a review')"
                        placement="bottom">
              <i class="fa fa-user-check" aria-hidden="true"></i>
            </el-tooltip>
          </div>
          <div v-if="!readOnly" class="col-auto col-actions">
            <el-dropdown trigger="click" class="dropdown">
              <span class="btn btn-flat">
                <i class="fas fa-ellipsis-v"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <a class="dropdown-item text-warning" @click="confirmDelete(task.id)"><i class="fas fa-trash-alt"></i>Удалить</a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </li>
    </transition-group>
  </draggable>
    <modal-delete-confirmation
      v-if="!readOnly"
      ref="block-delete-confirmation"
      v-model="showModal"
      :text="textModal"
      :id="idModal"
      @confirmed="onDeleteTask">
    </modal-delete-confirmation>
  </div>

</template>

<script>
  import draggable from "vuedraggable";
  import {Dropdown, DropdownMenu, Tooltip} from "element-ui";
  import ModalDeleteConfirmation from "../Modals/ModalDeleteConfirmation";
  import {createNamespacedHelpers} from 'vuex';
  import {DeleteConfirmation} from "../../mixins/DeleteConfirmation";

  const {mapActions} = createNamespacedHelpers('course/task');

  export default {
    name: "TaskDraggableList",
    mixins: [DeleteConfirmation],
    components: {
      [Tooltip.name]: Tooltip,
      [Dropdown.name]: Dropdown,
      [DropdownMenu.name]: DropdownMenu,
      draggable,
      ModalDeleteConfirmation
    },
    data() {
      return {
        taskTypesAdd: [
          {key: 'quiz', name: this.$i18n.t('Quiz')},
          {key: 'form', name: this.$i18n.t('Form')}
        ]
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default: null
      },
      list: {
        required: false,
        type: Array,
        default: null
      },
      lessonId: {
        required: true,
        type: Number
      },
      blockId: {
        required: true,
        type: Number
      },
      readOnly: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      },
      baseUrlParams() {
        return {
          courseId: this.$route.params.courseId,
          blockId: this.blockId,
          lessonId: this.lessonId
        }
      },
      urlParams() {
        return (id = undefined) => {
          return id ? {...this.baseUrlParams, taskId: id} : this.baseUrlParams
        }
      },
      realValue() {
        return this.value ? this.value : this.list;
      },
      textModal() {
         return this.$i18n.t('modal.taskDelete.text', this.idModal)
      },
      editTaskRoute() {
        return (taskType, taskId) => {
          return {
            name: `task-${taskType}-edit`,
            params: this.urlParams(taskId)
          }
        }
      },
      publicTaskPageUrl() {
        return (taskId) => {
          return {
            name: 'add-task-answer',
            params: this.urlParams(taskId)
          }
        }
      }
    },
    methods: {
      emitter(value) {
        this.$emit("input", value);
      },
      onMove(evt) {
        return evt.related.classList.contains('task-group');
      },
      async onDeleteTask(id) {
        this.$wait.start('course content fetching');
        await this.deleteTask({
          urlParams: this.urlParams(id)
        });
        await this.$store.dispatch('course/content/load', {urlParams: this.$route.params})
        this.$wait.end('course content fetching');
      },
      ...mapActions({
        deleteTask: 'deleteTask'
      }),
    },
  };
</script>
